import { LineChart } from "@mui/x-charts/LineChart";
import { format } from "date-fns";

export default function BasicLineChart({ apiData = [] }) {
  const xAxisData = apiData.map((item) =>
    format(new Date(item.SaleDate), "dd MMM")
  );

  const seriesData = apiData.map((item) => item.DailySales);

  return (
    <div className="bg-white h-[300px] w-full rounded-3xl">
      <LineChart
        xAxis={[
          {
            scaleType: "point",
            data: xAxisData,
          },
        ]}
        series={[
          {
            data: seriesData,
            label: "Daily Sales",
            color: "#2563EB",
          },
        ]}
        height={300}
      />
    </div>
  );
}
